import { Link } from "react-router-dom";
import ServerPanel from "../components/ServerPanel";
import Activity from "../components/Activity";
import { useDashboard } from "./Dashboard";

/**
 * The server itself: where it lives, what it is called, how to install it -- and what it
 * has been doing. Everything on this page is true for the lifetime of the account; the
 * URL and the token on it are the two things the user is promised never change.
 *
 * What the server *exposes* is the other page.
 */
export default function Setup() {
  const {
    project,
    server,
    token,
    onToken,
    oauthClient,
    activity,
    catalog,
    liveConnections,
    toolCount,
    notify,
  } = useDashboard();

  if (!project) return null;

  return (
    <>
      <ServerPanel
        projectId={project.id}
        server={server}
        token={token}
        onToken={onToken}
        oauthClient={oauthClient}
        activeCount={liveConnections.length}
        toolCount={toolCount}
        notify={notify}
      />

      {/* Installed, but exposing nothing: the one dead end this page can leave the user
          in, so it is also the one place that points at the other page. */}
      {liveConnections.length === 0 && (
        <section className="section">
          <div className="empty">
            <p>This server exposes no tools yet.</p>
            <p className="empty-sub">
              Connect a service on <Link to="/providers">Providers</Link> and switch it
              on. Its tools appear in your AI client without touching the config above.
            </p>
          </div>
        </section>
      )}

      <Activity logs={activity} catalog={catalog} />
    </>
  );
}
